// import React from 'react'
// import Logo from '../assets/images/image1.png'
// import appstore from "../assets/images/app-store.svg"
// import playstore from "../assets/images/google-play.svg"
// const Footer = ({ onContactClick, onPrivacyClick, onTermsClick }) => {
//   const currentYear = new Date().getFullYear();

//   const getHeaderHeight = () => {
//     const header = document.querySelector('.main-header');
//     return header ? header.offsetHeight : 0;
//   };

//   const scrollToSection = (elementId) => {
//     const element = document.querySelector(`#${elementId}`);
//     if (element) {
//       const headerHeight = getHeaderHeight();
//       const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
//       const offsetPosition = elementPosition - headerHeight;
      
//       window.scrollTo({
//         top: offsetPosition,
//         behavior: "smooth"
//       });
//     }
//   };

//   return (
//     <>
//       <footer className="main-footer">
//         {/* Upper Footer Section */}
//         <div className="footer-upper">
//           <div className="footer-container">
//             <div className="footer-left">
//               <div className="footer-logo-section">
//                 <img src={Logo} alt="Logo" className="footer-logo" />
//               </div>
//               <nav className="footer-nav">
//                 {/* <a href="#home" className="footer-nav-link">Home</a>
//                 <a href="#our-apps" className="footer-nav-link">Our Apps</a>
//                 <a href="#about" className="footer-nav-link">About</a>
//                 <a href="#faq" className="footer-nav-link">FAQ</a> */}

//                 <a
//                   href="#home"
//                   className="footer-nav-link"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     window.location.hash = "#home";
//                     setTimeout(() => {
//                       window.scrollTo({ top: 0, behavior: "smooth" });
//                     }, 100);
//                   }}
//                 >
//                   Home
//                 </a>

//                 <a
//                   href="#our-apps"
//                   className="footer-nav-link"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     window.location.hash = "#home";
//                     setTimeout(() => {
//                       scrollToSection("our-apps");
//                     }, 100);
//                   }}
//                 >
//                   Featured Apps
//                 </a>


//                 <a
//                   href="#about"
//                   className="footer-nav-link"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     window.location.hash = "#home";
//                     setTimeout(() => {
//                       scrollToSection("about");
//                     }, 100);
//                   }}
//                 >
//                   About
//                 </a>

//                 <a
//                   href="#faq"
//                   className="footer-nav-link"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     window.location.hash = "#home";
//                     setTimeout(() => {
//                       scrollToSection("faq");
//                     }, 100);
//                   }}
//                 >
//                   FAQ
//                 </a>
//                 <a 
//                   href="#contact" 
//                   className="footer-nav-link"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     if (onContactClick) {
//                       onContactClick();
//                     }
//                   }}
//                 >
//                   Contact Us
//                 </a>
//               </nav>
//             </div>
//             <div className="footer-right">
//               <div className="footer-app-download">
//                 <a
//                   href="https://apps.apple.com/sb/developer/di-labs/id1221305504"
//                   rel="noopener noreferrer"
//                 >
//                   <img src={appstore} alt="App Store" className="img-fluid" width="190" height="60" />
//                 </a>
//                 <a 
//                   href="https://play.google.com/store/apps/dev?id=6717661217853138886" 
//                   rel="noopener noreferrer"
//                 >
//                   <img src={playstore} alt="Google Play" className="img-fluid" width="190" height="60" />
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Bottom Bar Section */}
//         <div className="footer-bottom">
//           <div className="footer-container">
//             <div className="footer-bottom-left">
//               <p className="footer-copyright">Copyright &copy; {currentYear}. All rights reserved.</p>
//             </div>
//             <div className="footer-bottom-right">
//               <a 
//                 href="#terms" 
//                 className="footer-bottom-link"
//                 onClick={(e) => {
//                   e.preventDefault();
//                   if (onTermsClick) {
//                     onTermsClick();
//                   }
//                 }}
//               >
//                 Terms & condition
//               </a>
//               <span className="footer-separator">|</span>
//               <a 
//                 href="#privacy" 
//                 className="footer-bottom-link"
//                 onClick={(e) => {
//                   e.preventDefault();
//                   if (onPrivacyClick) {
//                     onPrivacyClick();
//                   }
//                 }}
//               >
//                 Privacy policy
//               </a>
//             </div>
//           </div>
//         </div>
//       </footer>
//     </>
//   )
// }

// export default Footer


import React from 'react'
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter, FaApple } from 'react-icons/fa';
import { FiArrowRight, FiFileText, FiHeadphones, FiLock, FiMail } from 'react-icons/fi';
import { MdAndroid } from "react-icons/md";
import { BiLogoPlayStore } from "react-icons/bi";
import Logo from '../assets/images/dilabslogo.png'
const Footer = ({ onContactClick, onPrivacyClick, onTermsClick }) => {
  const currentYear = new Date().getFullYear();

  const getHeaderHeight = () => {
    const header = document.querySelector('.main-header');
    return header ? header.offsetHeight : 0;
  };

  const scrollToSection = (elementId) => {
    const element = document.querySelector(`#${elementId}`);
    if (element) {
      const headerHeight = getHeaderHeight();
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerHeight - 40;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  return (
    <>
      <footer className="main-footer">
        {/* Upper Footer Section */}
        <div className="footer-upper">
          <div className="footer-container">
            <div className="footer-brand-column">
              <div className="footer-logo-section">
                <img src={Logo} alt="Logo" className="footer-logo" />
              </div>
              <p className="footer-description">
                We build high performance, beautiful apps that empower businesses and delight millions of users worldwide.
              </p>
              <div className="footer-socials" aria-label="Social links">
                <a href="https://www.facebook.com/" className="footer-social-link" aria-label="Facebook" rel="noopener noreferrer">
                  <FaFacebookF />
                </a>
                <a href="https://twitter.com/" className="footer-social-link" aria-label="Twitter" rel="noopener noreferrer">
                  <FaTwitter />
                </a>
                <a href="https://www.linkedin.com/" className="footer-social-link" aria-label="LinkedIn" rel="noopener noreferrer">
                  <FaLinkedinIn />
                </a>
                <a href="https://www.instagram.com/" className="footer-social-link" aria-label="Instagram" rel="noopener noreferrer">
                  <FaInstagram />
                </a>
              </div>
            </div>

            <div className="footer-link-column">
              <h3 className="footer-column-title">Company</h3>
              <nav className="footer-nav">
                <a
                  href="#home"
                  className="footer-nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.hash = "#home";
                    setTimeout(() => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }, 100);
                  }}
                >
                  Home
                  <FiArrowRight className="footer-link-arrow" aria-hidden="true" />
                </a>

                <a
                  href="#about"
                  className="footer-nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.hash = "#home";
                    setTimeout(() => {
                      scrollToSection("about");
                    }, 100);
                  }}
                >
                  About Us
                  <FiArrowRight className="footer-link-arrow" aria-hidden="true" />
                </a>

                <a
                  href="#our-apps"
                  className="footer-nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.hash = "#home";
                    setTimeout(() => {
                      scrollToSection("our-apps");
                    }, 100);
                  }}
                >
                  Our Apps
                  <FiArrowRight className="footer-link-arrow" aria-hidden="true" />
                </a>

                <a
                  href="#why-choose-us"
                  className="footer-nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.hash = "#home";
                    setTimeout(() => {
                      scrollToSection("why-choose-us");
                    }, 100);
                  }}
                >
                  Why Choose Us
                  <FiArrowRight className="footer-link-arrow" aria-hidden="true" />
                </a>

                <a
                  href="#faq"
                  className="footer-nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.hash = "#home";
                    setTimeout(() => {
                      scrollToSection("faq");
                    }, 100);
                  }}
                >
                  FAQ
                  <FiArrowRight className="footer-link-arrow" aria-hidden="true" />
                </a>
                <a 
                  href="#contact" 
                  className="footer-nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    if (onContactClick) {
                      onContactClick();
                    }
                  }}
                >
                  Contact Us
                  <FiArrowRight className="footer-link-arrow" aria-hidden="true" />
                </a>
              </nav>
            </div>

            <div className="footer-link-column footer-resources-column">
              <h3 className="footer-column-title">Resources</h3>
              <nav className="footer-resource-list">
                <a 
                  href="#terms" 
                  className="footer-resource-link"
                  onClick={(e) => {
                    e.preventDefault();
                    if (onTermsClick) {
                      onTermsClick();
                    }
                  }}
                >
                  <FiFileText className="footer-resource-icon" aria-hidden="true" />
                  Terms & Condition
                </a>
                <a 
                  href="#privacy" 
                  className="footer-resource-link"
                  onClick={(e) => {
                    e.preventDefault();
                    if (onPrivacyClick) {
                      onPrivacyClick();
                    }
                  }}
                >
                  <FiLock className="footer-resource-icon" aria-hidden="true" />
                  Privacy Policy
                </a>
                <a href="#contact" className="footer-resource-link" onClick={(e) => {
                  e.preventDefault();
                  if (onContactClick) {
                    onContactClick();
                  }
                }}>
                  <FiHeadphones className="footer-resource-icon" aria-hidden="true" />
                  Support Center
                </a>
                <a href="mailto:support@dilabs.com" className="footer-resource-link">
                  <FiMail className="footer-resource-icon" aria-hidden="true" />
                  support@dilabs.com
                </a>
              </nav>
            </div>

            <div className="footer-download-column">
              <h3 className="footer-column-title">Download Our Apps</h3>
              <div className="footer-app-download">
                  <a 
                  href="https://play.google.com/store/apps/dev?id=6717661217853138886" 
                  rel="noopener noreferrer"
                  className="header-contact-btn home-store-btn"
                >
                  <BiLogoPlayStore size={20} />
                  Play Store
                </a>
                <a
                  href="https://apps.apple.com/sb/developer/di-labs/id1221305504"
                  rel="noopener noreferrer"
                  className="header-contact-btn home-store-btn"
                >
                  <FaApple size={20} />
                  App Store
                </a>
              
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar Section */}
        <div className="footer-bottom">
          <div className="footer-container">
            <div className="footer-bottom-left">
              <p className="footer-copyright">Copyright &copy; {currentYear}. All rights reserved.</p>
            </div>
            <div className="footer-bottom-right">
              <a 
                href="#terms" 
                className="footer-bottom-link"
                onClick={(e) => {
                  e.preventDefault();
                  if (onTermsClick) {
                    onTermsClick();
                  }
                }}
              >
                Terms & condition
              </a>
              <span className="footer-separator">|</span>
              <a 
                href="#privacy" 
                className="footer-bottom-link"
                onClick={(e) => {
                  e.preventDefault();
                  if (onPrivacyClick) {
                    onPrivacyClick();
                  }
                }}
              >
                Privacy policy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer
